// extracted by mini-css-extract-plugin
export default {"multiValues":"autoselect_values-module___multiValues___dc04b645","badge":"autoselect_values-module___badge___b86dc6da"};